import React, {useLayoutEffect, useRef, useState} from 'react';
import { Button, Popover } from 'antd';
import './DestinationList.less';
import {exportTextInRef} from "common/util/export-text-in-ref";

/** Draws one continuous outline, keeping a fixed-size arrowhead as its label resizes. */
const DestArrow = ({children, order}) => {
    const ref = useRef(null);
    const [width, setWidth] = useState(0);

    useLayoutEffect(() => {
        const element = ref.current;
        const measure = () => setWidth(element.offsetWidth);
        measure();

        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', measure);
            return () => window.removeEventListener('resize', measure);
        }

        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [children]);

    // All edges belong to this closed path; no CSS borders or overlapping SVG seams.
    const outline =
        width > 0
            ? `M1,1 H${width - 11} L${width - 1},11 L${width - 11},21 H1 ${
                  order > 0 ? 'L11,11' : ''
              } Z`
            : undefined;

    return (
        <div className={order > 0 ? 'arrowbox arrowbox-continuation' : 'arrowbox'} ref={ref}>
            <svg
                className="arrowbox-outline"
                viewBox={`0 0 ${width || 1} 22`}
                aria-hidden="true"
                focusable="false"
            >
                <path className="arrowbox-fill" d={outline} />
                <path className="arrowbox-stroke" d={outline} />
            </svg>
            <span className="arrowbox-text">{children}</span>
        </div>
    );
};

/**
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{data: any}> & React.RefAttributes<HTMLDivElement>>}
 */
const DestinationList = React.forwardRef(({ data }, ref) => {
    const truncatedData = data.slice(0, 5);
    const isTruncated = truncatedData.length < data.length;

    const text = data?.map(dest => dest).join(' -> ');
    const newRef = exportTextInRef(text, ref);

    return (
        <div ref={newRef}>
            {truncatedData.map((dest, i) => (
                <DestArrow key={i} order={i} >{dest}</DestArrow>
            ))}
            {isTruncated && (
                <Popover content={
                    <div style={{marginRight: '-8px'}}>
                        {data.slice(5).map((dest, i) => (
                            <DestArrow key={i} order={1-i} >{dest}</DestArrow>
                        ))}
                    </div>
                }>
                    <Button className="mc-link-btn">See more</Button>
                </Popover>
            )}
        </div>
    )
})

export default DestinationList
